/*
 * @Descripttion: canvas工具类
 * @FilePath: /mall-wap-vue/src/utils/canvas.js
 * @Author: 张兴业
 * @Date: 2020-10-28 21:20:25
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-10-28 22:34:00
 */
// 绘制圆角矩形
export function fillRoundRect(cxt, x, y, width, height, radius, fillColor) {
  // 圆的直径必然要小于矩形的宽高
  if (2 * radius > width || 2 * radius > height) {
    return false;
  }
  cxt.save();
  cxt.translate(x, y);
  // 绘制圆角矩形的各个边
  drawRoundRectPath(cxt, width, height, radius);

  // eslint-disable-next-line no-param-reassign
  cxt.fillStyle = fillColor || "#000"; // 若是给定了值就用给定的值否则给予默认值
  cxt.fill();
  cxt.restore();
}

export function drawRoundRectPath(cxt, width, height, radius) {
  cxt.beginPath(0);
  // 从右下角顺时针绘制，弧度从0到1/2PI
  cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);

  // 矩形下边线
  cxt.lineTo(radius, height);

  // 左下角圆弧，弧度从1/2PI到PI
  cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);

  // 矩形左边线
  cxt.lineTo(0, radius);

  // 左上角圆弧，弧度从PI到3/2PI
  cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);

  // 上边线
  cxt.lineTo(width - radius, 0);

  // 右上角圆弧
  cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);

  // 右边线
  cxt.lineTo(width, height - radius);
  cxt.closePath();
}

// 绘制圆角矩形
export function fillRoundRectEvery(
  cxt,
  x,
  y,
  width,
  height,
  br,
  bl,
  tl,
  tr,
  fillColor
) {
  // 圆的直径必然要小于矩形的宽高
  if (2 * br > width || 2 * bl > width || 2 * tl > height || 2 * tr > height) {
    return false;
  }
  cxt.save();
  cxt.translate(x, y);
  // 绘制圆角矩形的各个边
  drawRoundRectPathEvery(cxt, width, height, br, bl, tl, tr);

  // eslint-disable-next-line no-param-reassign
  cxt.fillStyle = fillColor || "#000"; // 若是给定了值就用给定的值否则给予默认值
  cxt.fill();
  cxt.restore();
}

export function drawRoundRectPathEvery(cxt, width, height, br, bl, tl, tr) {
  cxt.beginPath(0);
  // 从右下角顺时针绘制，弧度从0到1/2PI
  cxt.arc(width - br, height - br, br, 0, Math.PI / 2);

  // 矩形下边线
  cxt.lineTo(br, height);

  // 左下角圆弧，弧度从1/2PI到PI
  cxt.arc(bl, height - bl, bl, Math.PI / 2, Math.PI);

  // 矩形左边线
  cxt.lineTo(0, bl);

  // 左上角圆弧，弧度从PI到3/2PI
  cxt.arc(tl, tl, tl, Math.PI, (Math.PI * 3) / 2);

  // 上边线
  cxt.lineTo(width - tl, 0);

  // 右上角圆弧
  cxt.arc(width - tr, tr, tr, (Math.PI * 3) / 2, Math.PI * 2);

  // 右边线
  cxt.lineTo(width, height - tr);
  cxt.closePath();
}

// 圆角图片
export function circleImg(ctx, img, x, y, w, h, r) {
  ctx.save();
  const cx = x + r;
  const cy = y + r;
  ctx.arc(cx, cy, r, 0, 2 * Math.PI);
  ctx.clip();
  ctx.drawImage(img, x, y, w, h);
  ctx.restore();
}
